module.exports = __webpack_public_path__ + "img/icon_benefit2@3x.53423134.png";